const TOKEN_KEY = 'token';
const ROLE_KEY  = 'auth_role';

export function useRememberMe() {
  const saveSession = (token, role) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(ROLE_KEY, role);
  };

  const clearSession = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(ROLE_KEY);
  };

  const getSavedToken = () => ({
    token: localStorage.getItem(TOKEN_KEY),
    role:  localStorage.getItem(ROLE_KEY),
  });

  return { saveSession, clearSession, getSavedToken };
}